import {
  Typography,
  Card,
  CardContent,
  CardHeader,
  Container,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import { useTranslation } from "react-i18next";

const Tutorial = () => {
  const { t } = useTranslation();

  return (
    <Card>
      <CardHeader title={t("guideCard.header")} />
      <CardContent>
        <Typography
          variant="body1"
          marginBottom={2}
          sx={{
            lineHeight: "1.9",
            wordWrap: "break-word",
            overflowWrap: "break-word",
            whiteSpace: "pre-wrap",
          }}
        >
          {t("guideCard.welcome")}
        </Typography>

        <Typography variant="h6" my={1}>
          {t("guideCard.notesTitle")}
        </Typography>
        <Typography
          variant="body1"
          marginBottom={3}
          sx={{
            lineHeight: "1.9",
            wordWrap: "break-word",
            overflowWrap: "break-word",
            whiteSpace: "pre-wrap",
          }}
        >
          {t("guideCard.notesDescription")}
          <AddIcon /> {t("guideCard.addNote")}
          <DeleteIcon /> {t("guideCard.deleteNote")}
          <EditIcon /> {t("guideCard.editNote")}
        </Typography>

        <Typography variant="h6" my={1}>
          {t("guideCard.profileTitle")}
        </Typography>
        <Typography
          variant="body1"
          marginBottom={1}
          sx={{
            lineHeight: "1.9",
            wordWrap: "break-word",
            overflowWrap: "break-word",
            whiteSpace: "pre-wrap",
          }}
        >
          {t("guideCard.profileDescription")}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default Tutorial;
